import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { color } from '../styles/helpers/variables';
import MainProductImage from '../components/MainProductImage';
import { ProductImage } from '../styles/ProductImage';
import { toCurrency } from '../util/toCurrency';
import { SITE_ROOT_URL } from '../constants/endpoints';
import { getProductVariantName } from '../util/getProductVariantName';
import { Conditional } from './Conditional';

const ProductConfigurationListItem = props => {
  const tagKey = props.children.get('tags') && props.children.get('tags').toKeyedSeq();

  return (
    <ProductConfigurationListItemContainer
      onClick={() => props.setProductVariant(props.children.get('id'), props.type)}
    >
      <ImageContainer>
        {props.fullImages ? (
          <ProductImage
            selected={
              props.type ? props.selected === props.children.get('id') : props.location === props.children.get('url')
            }
            margin="0 0 .5rem"
            src={SITE_ROOT_URL + props.children.getIn(['images', 0, 'url'])}
          />
        ) : (
          <MainProductImage selected={props.selected === props.children.get('id')} small>
            <ProductImage src={SITE_ROOT_URL + props.children.getIn(['mainImage', 'url'])} />
          </MainProductImage>
        )}
        <Conditional show={tagKey && !tagKey.isEmpty()}>
          <TagIndicatorContainer>
            {tagKey && tagKey.map(item => <TagIndicator color={item.get('key')} />).toArray()}
          </TagIndicatorContainer>
        </Conditional>
      </ImageContainer>
      <Title>
        {getProductVariantName(props.children.get('name'), true)}
        {props.children.get('price') ? (
          <span style={{ display: 'block', margin: 0, fontSize: '14px' }}>
            {toCurrency(props.children.get('price'))}
          </span>
        ) : (
          false
        )}
      </Title>
    </ProductConfigurationListItemContainer>
  );
};

const TagIndicatorContainer = styled.div`
  width: 100%;
  height: 8px;
  position: absolute;
  top: 5px;
  left: 5px;
  display: flex;
`;

const TagIndicator = styled.div`
  width: 8px;
  height: 8px;
  margin-right: 2px;
  background-color: ${props => props.color};
`;

const ImageContainer = styled.div`
  position: relative;

  &:after {
    content: '';
    background-color: ${color.black};
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    opacity: 0;
    transition: opacity 0.25s ease-out;
    pointer-events: none;
  }
`;

const ProductConfigurationListItemContainer = styled.div`
  width: 100%;
  margin: 5px 0 2px;
  cursor: pointer;

  &:hover {
    ${ImageContainer} {
      &:after {
        opacity: 0.05;
      }
    }
  }
`;

const Title = styled.p`
  font-size: 14px;
  line-height: 1.57;
  font-weight: 500;
  text-align: left;
  color: ${color.black};
  margin: 0;
`;

ProductConfigurationListItem.defaultProps = {
  fullImages: false,
  selected: '',
  type: ''
};

ProductConfigurationListItem.propTypes = {
  selected: PropTypes.string,
  setProductVariant: PropTypes.func.isRequired,
  fullImages: PropTypes.bool,
  type: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  location: PropTypes.string.isRequired
};

export default ProductConfigurationListItem;



// WEBPACK FOOTER //
// ./src/components/ProductConfigurationListItem.js